import { Button } from "@/atoms-react/button/Button.react";
import { useCompany } from "@/features/company/hooks/use-company";
import { Themes } from "@/types/theme";
import { PlusCircleIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LayoutTitle } from "../_layout/index.react";
import { CompanyList } from "./components/CompanyList";
import { useUserCheckAccess } from "@/features/user/hooks/use-user-check-access";
import { useUser } from "@/features/user/hooks/use-user";
import { usePartnerInfo } from "@/features/partner/hooks/use-partner-information";
import { identityPartners } from "@/features/user/types";

export const Company = () => {
  const { t } = useTranslation(["pass", "atoms"]);
  const [addCompany, setAddCompany] = useState<boolean>(false);
  const open = () => setAddCompany(true);
  const close = () => setAddCompany(false);

  const { companiesQuery } = useCompany();
  const { data: companyList, isFetching: loading } = companiesQuery();

  const { useUserProfile } = useUser();
  const { data: user } = useUserProfile();

  const partnerName = sessionStorage.getItem("origin");
  const { partnerUuidQuery } = usePartnerInfo();
  const { data: dataPartner } = partnerUuidQuery(partnerName);
  const identityPartner = (() => {
    if (user?.identityPartners) {
      const found = user?.identityPartners?.find(
        (partner: identityPartners) => partner.uuid === dataPartner?.data.partner_uuid
      );
      return found ?? null;
    }
    return null;
  })();

  const { checkPermission } = useUserCheckAccess();

  return (
    <>
      <LayoutTitle
        actionSupport={
          !!companyList && companyList!.length > 0 ? (
            <Button
              size="md"
              disabled={!checkPermission(null, user, null, identityPartner)}
              theme={Themes.primary}
              onClick={() => {
                setAddCompany(true);
              }}
              iconPosition="after"
              icon={<PlusCircleIcon />}
              dataCy="add-company-button"
              className="w-max"
            >
              {t("business.button.add_company")}
            </Button>
          ) : (
            <></>
          )
        }
      >
        <div className="flex items-center gap-x-2">{t("company.label.main_title")}</div>
      </LayoutTitle>
      <div>
        <CompanyList
          loading={loading}
          allowedToCreateCompany={checkPermission(null, user, null, identityPartner) || false}
          closeCompanyModal={close}
          addCompanyModal={open}
          openModal={addCompany}
          companies={companyList ?? []}
        />
      </div>
    </>
  );
};
